document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-header-loc-toggle]');
  if (toggle) {
    e.preventDefault();
    const type = toggle.getAttribute('data-header-loc-toggle');
    const list = document.querySelector(`[data-header-loc-list="${type}"]`);
    if (!list) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    list.hidden = expanded;
    return;
  }

  const item = e.target.closest('[data-header-loc-item]');
  if (item) {
    e.preventDefault();
    const type = item.getAttribute('data-header-loc-item'); // currency | locale
    const value = item.getAttribute('data-value');
    const form = item.closest('form');
    if (!form || !type || !value) return;

    const input = form.querySelector(`[data-header-loc-input="${type}"]`);
    if (!input) return;

    input.value = value;
    form.submit();
    return;
  }

  // Click outside closes any open lists
  if (!e.target.closest('.header-loc')) {
    document.querySelectorAll('[data-header-loc-list]').forEach((ul) => (ul.hidden = true));
    document.querySelectorAll('[data-header-loc-toggle]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  }
});


document.addEventListener('change', (e) => {
  const sel = e.target.closest('form.header-loc select[name="locale_code"], form.header-loc select[name="country_code"]');
  if (!sel) return;
  sel.closest('form').submit();
});